module.exports = __webpack_public_path__ + "static/img/fp_1_1.dd4fd24d.png";